import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {
  public contentHeader: object;

  public user: any
  public siteSettings: any = {
    site_logo: '',
    site_name: ''
  };
  submitted: boolean = false
  disable: boolean = false
  disable_c: boolean = false

  customer_name: any;
  customer_email: any;
  customer_phone: any;
  customer_kyc: any;

  kyc_type: any = {
    label: '',
    value: ''
  };
  
  kycMethods: any = [
    {
      label: 'BVN Number',
      value: 'BVN'
    },
    {
      label: 'NIN Number',
      value: 'NIN'
    }
  ]

  old_pass: any
  new_pass: any;

  constructor(
    private tokenStorage: TokenStorageService,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {
    
  }

  /**
   * On Init
   */
  ngOnInit() {
    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
      console.log('user: ', this.user)
      this.customer_name = this.user.name
      this.customer_email = this.user.email
      this.customer_phone = this.user.phone
      this.customer_kyc = this.user.kyc_value
    }

    // this.api.externalGet('list-service-category&serviceID=12').subscribe((response: any) => {
    //   this.selectBasic = response.data; 
    // });
    this._coreConfigService.sysConfig().subscribe(config => {
      // console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    // content header
    this.contentHeader = {
      headerTitle: 'Profile Update',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'Profile Update',
            isLink: false
          }
        ]
      }
    };
  }

  submitProfile() {
    this.submitted = true
    this.disable = true
    const param = {
      customer_name: this.customer_name,
      customer_phone: this.customer_phone,
      customer_email: this.customer_email,
      kyc_type: this.kyc_type.value,
      kyc_value: this.customer_kyc,
      action: 'profile'
    }
    this.api.post('change-details', param).subscribe((response: any) => {
      this.submitted = false
      this.disable = false
      if (response.success === true) {
        this.api.alerts("top-end", "success", response.message)
      }else{
        this.api.alerts("top-end", "error", response.message)
      }
    });
    
  }

  submitPassword() {
    this.disable_c = true
    const param = {
      oldpass: this.old_pass,
      newpass: this.new_pass,
      action: 'change_password'
    }
    this.api.post('change-details', param).subscribe((response: any) => {
      this.disable_c = false
      if (response.success === true) {
        this.api.alerts("top-end", "success", response.message)
      }else{
        this.api.alerts("top-end", "error", response.message)
      }
    });
    
  }

  selectKYCMethod($event) {
    // console.log($event)
    this.kyc_type = $event
  }

}

